/**
 * A venue's page on the public site (docs/public-site.spec.md, "A venue's page").
 */

/** How long the venue's description may be. The database holds it to this too. */
export const VENUE_PAGE_DESCRIPTION_MAX = 1000

/**
 * What a page needs before it can be turned on, and before it shows: the
 * venue's photo, an address the map can find, and a description. In the order
 * Venue setup lists them.
 */
export const VENUE_PAGE_NEEDS = ['photo', 'address', 'description'] as const

export type VenuePageNeed = (typeof VENUE_PAGE_NEEDS)[number]
